import { Checkbox } from "@single-js/common/components/form/checkbox";
import { Icon } from "@single-js/common/components/icon/icon";
import { RadioButton } from "@single-js/common/components/radio-button/radio-button";
import classnames from "classnames";
import * as React from "react";
import { logError } from "util/logging";
import { TextInput } from "view/common/text-input";
import "./form-element.scss";
export default class FormElement extends React.Component {
    render() {
        const { type, className, label, message, input, meta, meta: { error, ...metaBools }, ...rest } = this.props;
        // We are specifically overriding the onBlur handler such that it calls
        // this.props.onBlur with *no* event argument.  The reason is that
        // Redux-Form incorrectly updates the value of the field onBlur.
        // This is incorrect since in certain cases like autocompletion the
        // browser can fire multiple event-handlers in a single frame. When this
        // happens, the onBlur handle will see the stale input value rather than
        // the new, updated value.
        //
        // Discussion: https://github.com/erikras/redux-form/issues/2768
        // Test we are depending on:
        // https://github.com/erikras/redux-form/blob/38d58d9c9040d86efd3e09b079e7b3109c688f15/src/__tests__/reducer.blur.spec.js#L70
        const fixedInput = {
            ...input,
            onBlur: () => {
                // @ts-ignore
                input.onBlur();
            },
        };
        const classes = classnames({
            "components-form-element": true,
            ...metaBools,
        }, className);
        let inputEl;
        if (typeof type === "string") {
            if (type === "textarea") {
                inputEl = (React.createElement(TextInput, { type: "textarea", input: fixedInput, meta: meta, ...rest }));
            }
            else if (type === "password") {
                inputEl = (React.createElement(TextInput, { type: "password", input: fixedInput, meta: meta, ...rest }));
            }
            else if (type === "text") {
                inputEl = (React.createElement(TextInput, { type: "text", input: fixedInput, meta: meta, ...rest }));
            }
            else if (type === "checkbox") {
                inputEl = React.createElement(Checkbox, { inputProps: { ...fixedInput, ...rest } });
            }
            else if (type === "radio") {
                const { checked, value, name, ...restInput } = fixedInput;
                inputEl = (React.createElement(RadioButton, { label: label, inputProps: {
                        meta,
                        name,
                        value,
                        checked: Boolean(checked),
                        ...rest,
                        ...restInput,
                    } }));
            }
            else {
                logError(new Error(`Unexpected FormElement type - ${type}`));
            }
        }
        else {
            const CustomInput = type;
            inputEl = React.createElement(CustomInput, { input: fixedInput, meta: meta, ...rest });
        }
        let messageEl;
        if (error && meta.touched) {
            messageEl = (React.createElement("div", { className: "message-wrapper" },
                React.createElement(Icon, { icon: "exclamation-triangle" }),
                " ",
                error));
        }
        else if (message) {
            messageEl = React.createElement("div", { className: "message-wrapper", children: message });
        }
        let inner;
        if (type === "checkbox") {
            inner = (React.createElement("div", { className: "checkbox-wrapper" },
                inputEl,
                React.createElement("div", { className: "content-wrapper" },
                    label && (React.createElement("label", { className: "checkbox-label", htmlFor: input.name, children: label })),
                    React.createElement("div", { className: "message-wrapper" }, messageEl))));
        }
        else if (type === "radio") {
            // no label because our RadioButton already has one
            inner = (React.createElement("div", { className: "checkbox-wrapper" },
                inputEl,
                React.createElement("div", { className: "content-wrapper" }, messageEl)));
        }
        else {
            inner = (React.createElement(React.Fragment, null,
                label && (React.createElement("div", { className: "label-wrapper" },
                    React.createElement("label", { htmlFor: input.name, children: label }))),
                inputEl,
                messageEl));
        }
        return React.createElement("div", { className: classes }, inner);
    }
}
